import { Component, OnInit } from '@angular/core';
import { FileExplorerComponent } from '../../file-explorer/file-explorer.component';
import { FileElement } from '../../interfaces/models/fileExplorer.model';
import { FileServiceService } from '../../services/file-service.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { StrategyService } from '../../services/strategy.service';
import { SocketService } from '../../services/socket.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { TranslateModule } from '@ngx-translate/core';
import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-navigate-proofs',
  standalone: true,
  imports: [
    NavTitlePipe,FileExplorerComponent, TranslateModule, FormsModule, DropdownModule, CommonModule],
  templateUrl: './navigate-proofs.component.html',
  styleUrl: './navigate-proofs.component.scss'
})
export class NavigateProofsComponent implements OnInit {
  selectedStrategyId = 0
  fileElements!: Observable<FileElement[]>;
  currentRoot!: FileElement;
  currentPath!: string;
  canNavigateUp = false;
  selectedStrategy = {} as Strategy;
  strategyOptions = [] as { name: string, strategyId: number }[];
  constructor(private fileService: FileServiceService, private socketService: SocketService, private strategyService: StrategyService) { }
  ngOnInit(): void {
    this.currentPath = ''; // Initialize currentPath
    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      let defultStrategy = strategies.find(x => x.is_default);
      this.fileService.getFilesList(defultStrategy?.id || 0).subscribe((response: any) => {
        this.fileService.addList(response['data']['files'])
        this.updateFileElementQuery();
      });
      this.selectedStrategyId = defultStrategy?.id || 0;
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })
  }
  addFolder(folder: { name: string }) {
    console.log('addFolder', folder);
    this.fileService.add({
      isFolder: true,
      name: folder.name,
      parent: this.currentRoot ? this.currentRoot.id as string : 'root'
    });
    this.updateFileElementQuery();
  }

  removeElement(element: FileElement) {
    this.fileService.delete(element.id as string);
    this.updateFileElementQuery();
  }

  moveElement(event: { element: FileElement; moveTo: FileElement }) {
    this.fileService.update(event.element.id as string, { parent: event.moveTo.id });
    this.updateFileElementQuery();
  }

  renameElement(element: FileElement) {
    console.log("bla", element);
    this.fileService.update(element.id as string, { name: element.name });
    this.updateFileElementQuery();
  }
  updateFileElementQuery() {
    console.log("updateFileElementQuery", this.currentRoot);
    console.log("files", this.fileService.queryInFolder(this.currentRoot?.id ? this.currentRoot.id : 'root'));
    this.fileElements = this.fileService.queryInFolder(this.currentRoot?.id ? this.currentRoot.id : 'root');
  }

  navigateUp() {
    if (this.currentRoot && this.currentRoot.parent === 'root') {
      this.currentRoot = {} as FileElement;
      this.canNavigateUp = false;
      this.updateFileElementQuery();
    } else {
      this.currentRoot = this.fileService.get(this.currentRoot.parent) as FileElement;
      this.updateFileElementQuery();
    }

    this.currentPath = this.popFromPath(this.currentPath || '');
  }

  navigateToFolder(element: FileElement) {
    this.currentRoot = element;
    this.updateFileElementQuery();
    this.currentPath = this.pushToPath(this.currentPath || '', element.name);
    this.canNavigateUp = true;
  }

  pushToPath(path: string, folderName: string) {
    let p = path ? path : '';
    p += `${folderName}/`;
    return p;
  }

  popFromPath(path: string) {
    let p = path ? path : '';
    let split = p.split('/');
    split.splice(split.length - 2, 1);
    p = split.join('/');
    return p;
  }
  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.fileService.getFilesList(this.selectedStrategy?.id).subscribe((response: any) => {
        this.fileService.addList(response['data']['files'])
        this.currentRoot = { parent: 'root' } as FileElement;
        this.currentPath = ''
        this.updateFileElementQuery();

      });
    })
    // this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }

}
